import { render, staticRenderFns } from "./ExplanationHint.vue?vue&type=template&id=4864ef80&scoped=true&"
import script from "./ExplanationHint.vue?vue&type=script&lang=ts&"
export * from "./ExplanationHint.vue?vue&type=script&lang=ts&"
import style0 from "./ExplanationHint.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ExplanationHint.vue?vue&type=style&index=1&id=4864ef80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4864ef80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VExpandTransition,VIcon})
